module.exports = __webpack_public_path__ + "img/folder.52cae33e.png";